module.exports = __webpack_public_path__ + "img/ontomap_logo-retina-orange.0b4b4528.png";